import { Link } from "react-router-dom";
import { useI18n } from "../../lib/i18n";
import { PHONE, PHONE_DISPLAY, EMAIL } from "../../lib/api";
import { Logo } from "./Logo";

export const Footer = () => {
  const { t } = useI18n();
  const f = t.footer;
  const rows = [
    [f.company, "CARS 99 DI VALENTINO NIMIS"],
    [f.nature, f.natureVal],
    [f.vat, "03029620303"],
    [f.cf, "NMSVNT86B04H816Y"],
    [f.rea, "UD - 360553"],
    [f.hq, "Via Cividina, 99 – 33100 Udine (UD)"],
    [f.op, "Via Cividina, 99 – 33100 Udine (UD)"],
  ];
  return (
    <footer className="relative overflow-hidden bg-ink text-pearl" data-testid="site-footer">
      <div className="mx-auto max-w-[1440px] px-5 pb-10 pt-20 sm:px-8 lg:px-12">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <Logo light />
            <div className="mt-8 space-y-2 text-base">
              <a href={`tel:${PHONE}`} className="block text-zinc-200 hover:text-champagne-light" data-testid="footer-phone">{PHONE_DISPLAY}</a>
              <a href={`mailto:${EMAIL}`} className="block text-zinc-200 hover:text-champagne-light" data-testid="footer-email">{EMAIL}</a>
            </div>
          </div>
          <div className="lg:col-span-8">
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-champagne-light">{f.legal}</p>
            <dl className="mt-6 grid gap-x-10 gap-y-5 sm:grid-cols-2" data-testid="footer-legal">
              {rows.map(([k, v]) => (
                <div key={k} className="border-t border-white/10 pt-3">
                  <dt className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-400">{k}</dt>
                  <dd className="mt-1 text-sm text-zinc-100">{v}</dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
        <p className="mt-20 select-none font-display text-[18vw] font-extrabold uppercase leading-[0.8] tracking-[-0.05em] text-white/[0.06] lg:text-[11rem]" aria-hidden="true">
          Cars 99
        </p>
        <div className="mt-6 flex flex-col justify-between gap-3 border-t border-white/10 pt-6 text-xs text-zinc-400 sm:flex-row">
          <span>© {new Date().getFullYear()} CARS 99 DI VALENTINO NIMIS · P.IVA 03029620303 · {f.rights}</span>
          <Link to="/admin" className="hover:text-champagne-light" data-testid="footer-admin-link">{f.admin}</Link>
        </div>
      </div>
    </footer>
  );
};
